import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/home';

export default function LatestSection() {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-950">最新更新</h2>
            <p className="text-sm text-foreground-500 mt-1">实时更新，追剧不等待</p>
          </div>
          <div className="flex items-center gap-2">
            <button className="px-4 py-1.5 text-xs font-medium rounded-full bg-primary-500 text-white whitespace-nowrap cursor-pointer">
              全部
            </button>
            <button className="px-4 py-1.5 text-xs font-medium rounded-full bg-background-200 text-foreground-600 hover:bg-background-300 transition-colors whitespace-nowrap cursor-pointer">
              电视剧
            </button>
            <button className="px-4 py-1.5 text-xs font-medium rounded-full bg-background-200 text-foreground-600 hover:bg-background-300 transition-colors whitespace-nowrap cursor-pointer hidden sm:block">
              电影
            </button>
            <button className="px-4 py-1.5 text-xs font-medium rounded-full bg-background-200 text-foreground-600 hover:bg-background-300 transition-colors whitespace-nowrap cursor-pointer hidden sm:block">
              动漫
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {latestUpdates.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative w-full aspect-video overflow-hidden">
                <img
                  src={video.cover}
                  alt={video.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 right-2 px-1.5 py-0.5 text-xs rounded bg-black/60 text-white whitespace-nowrap">
                  {video.updateEpisode}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                    <i className="ri-play-fill text-lg"></i>
                  </div>
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-xs md:text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {video.title}
                </h3>
                <div className="flex items-center justify-between mt-2 text-xs text-foreground-400">
                  <span className="whitespace-nowrap">{video.category}</span>
                  <span className="whitespace-nowrap">{video.updateTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}